import { CONFIG } from '../core/config';
import { ModifiableEntity } from './editable-entity';
import { Lookup } from './lookups/lookup';
import { Node } from './node';
import { Unit } from './unit';
import { ViewModel } from './view-model';

export class NodeInput extends ModifiableEntity implements ViewModel {
  readonly friendlyTypeNameSingular = 'Node Input';
  readonly apiRoute: string = CONFIG.apiRoutes.nodeInput;

  nodeInputId: string;
  identifier: string;
  label: string;
  required: boolean;
  defaultValue: string;
  source: string = DataSource.User.toString();
  sourceMapping: string;
  nodeId: string;
  node: Node;
  dataType: NodeInputDataType = NodeInputDataType.Number;
  uomId: string;
  UOM: Unit = new Unit();
  lookup: Lookup = new Lookup();
  groupName: string;
  defaultLookupValue: string;

  constructor() {
    super();
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);
    this.nodeInputId = data.nodeInputId;
    this.identifier = data.identifier;
    this.label = data.label;
    this.required = data.required;
    this.defaultValue = data.defaultValue;
    this.source = data.source;
    this.sourceMapping = data.sourceMapping;
    this.nodeId = data.nodeId;
    this.node = data.node;
    this.dataType = data.dataType;
    this.groupName = data.groupName;
    this.defaultLookupValue = '';
    this.uomId = data.uomId;

    if (data.uom) {
      this.UOM = new Unit();
      this.UOM.loadFromJson(data.uom);
    }

    if (data.lookup) {
      this.lookup = new Lookup();
      this.lookup.loadFromJson(data.lookup);
    }
  }
}

/**
 * Defines the type of data for a node input
 */
export enum NodeInputDataType {
  Number = 1,
  Text = 2,
  DateTime = 3,
  Boolean = 4,
  Lookup = 5,
  Calibration = 6,
  ProbabilityCategory = 7,
  ConsequenceCategory = 8,
  Universal = 9
}

/**
 * Defines where the data for an input comes from, i.e. entered manually, or from another node, etc.
 */
export enum DataSource {
  User = 1,
  /**
   * Do not use lookup datasource.  Lookups are defined by the datatype
   */
  Lookup = 2,
  InternalMapping = 3,
  ExternalMapping = 4,
}
